var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6338",
    "data-name": "Rectangle 6338",
    width: 33.476,
    height: 35.696,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34955",
    "data-name": "Group 34955",
    transform: "translate(-5319 -5404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(5319 5404)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34891",
    "data-name": "Group 34891",
    transform: "translate(5339 5423.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34890",
    "data-name": "Group 34890",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24440",
    "data-name": "Path 24440",
    d: "M20.643,0A9.593,9.593,0,0,1,22.3.586a4.27,4.27,0,0,1,2.242,3.908c.017,2.115.011,4.23,0,6.344,0,.3.064.433.374.529a5.924,5.924,0,0,1,4.1,5.55c-.038,2.869-.011,5.739-.007,8.609a1.117,1.117,0,1,0,2.224.2c.009-.1.006-.209.006-.314q0-6.5.006-13a.521.521,0,0,0-.315-.533,3.419,3.419,0,0,1-1.872-2.8A4.272,4.272,0,0,1,29.1,8.5c-.542-.274-1.117-.55-1.676-.852a1.046,1.046,0,0,1-.57-1.136.973.973,0,0,1,.772-.886,1.392,1.392,0,0,1,.837.079c1.464.7,2.911,1.443,4.362,2.171a1.181,1.181,0,0,1,.656,1.172q-.008,3.416,0,6.831,0,4.792,0,9.585a3.339,3.339,0,0,1-6.636.663,8.037,8.037,0,0,1-.054-.9c0-2.788,0-5.577,0-8.365a3.538,3.538,0,0,0-2.209-3.252c-.007.1-.02.2-.02.3q0,7.6-.006,15.2a.416.416,0,0,0,.274.45c.433.195.854.418,1.279.632a1.169,1.169,0,0,1,.684,1.122c0,1.068.006,2.137,0,3.206a1.093,1.093,0,0,1-1.2,1.18q-12.132,0-24.263,0A1.185,1.185,0,0,1,0,34.4c0-1.011.007-2.022,0-3.032A1.233,1.233,0,0,1,.753,30.15c.387-.186.76-.406,1.155-.567a.494.494,0,0,0,.332-.555q-.012-7.2-.006-14.395V4.77A4.468,4.468,0,0,1,6.122.05.308.308,0,0,0,6.209,0Zm3.905,33.458c0-.446-.009-.861,0-1.277a.359.359,0,0,0-.242-.4c-.34-.148-.658-.349-1-.487a1.5,1.5,0,0,1-1-1.6q.029-12.513.012-25.026a2.212,2.212,0,0,0-2.44-2.441H7.012A2.3,2.3,0,0,0,4.466,4.775q0,12.548.005,25.1A1.3,1.3,0,0,1,3.658,31.2c-.412.186-.813.4-1.213.607-.082.043-.2.131-.2.2-.018.481-.009.964-.009,1.451Z",
    transform: "translate(0 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24441",
    "data-name": "Path 24441",
    d: "M15.971,7.733q2.7,0,5.4,0a1.146,1.146,0,0,1,1.3,1.308q0,4.269,0,8.538a1.146,1.146,0,0,1-1.3,1.307q-5.4,0-10.806,0A1.14,1.14,0,0,1,9.286,17.6q0-4.287,0-8.572a1.14,1.14,0,0,1,1.283-1.29q2.7,0,5.4,0m4.455,2.256H11.545v6.65h8.882Z",
    transform: "translate(-2.588 -2.155)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelStation);
export default __webpack_public_path__ + "static/media/fuelStation.1704dfb8fb3c23a340179634e4bb432c.svg";
export { ForwardRef as ReactComponent };